import React from 'react'
import { TextField, Grid, Typography, Divider } from '@material-ui/core'
import { SelecionarData, Page, Header, CustomButton, ModalConfirmacao } from 'components'
import { cutMaxLength } from 'utils/helpers'
import Autocomplete from '@material-ui/lab/Autocomplete'
import ArrowBackIcon from '@material-ui/icons/ArrowBack'
import CheckIcon from '@material-ui/icons/Check'
import useStyles from './styles'
import { useDescartarVestigio } from './hooks/useDescartarVestigio'

const maxLength250 = (newValue) => cutMaxLength(newValue, 250)

export const DescartarVestigio = (props) => {
  const { route } = props
  const classes = useStyles()

  const {
    values,
    autorizadoUsuarioObj,
    usuarios,
    dataCadastroVestigio,
    processando,
    modalConfirmacao,
    handleChangeAutorizadoUsuario,
    handleChangeWithModification,
    setDataAutorizacao,
    fecharModalConfirmacao,
    abrirModalConfirmacao,
    descartarVestigio,
    isFormValid,
    router,
    params,
  } = useDescartarVestigio()

  return (
    <Page className={classes.root} title={`${route.titulo} - SIGEP`}>
      <Header titulo={route.titulo} overline={route.secao} pathname={router.location.pathname} router={router} />
      
      <div className={classes.results}>
        <Grid container spacing={2}>
          <Grid item md={6} sm={6} xs={12}>
            <Autocomplete
              name="autorizacaousuario"
              noOptionsText="Sem informações"
              value={autorizadoUsuarioObj}
              options={usuarios}
              onChange={handleChangeAutorizadoUsuario}
              getOptionSelected={(option, value) => option.id === value?.id}
              getOptionLabel={(option) => `${option.nome || ''}${option.cargo?.nome ? ` - ${option.cargo.nome.toUpperCase()}` : ''}`}
              renderOption={(option) => `${option.nome || ''}${option.cargo?.nome ? ` - ${option.cargo.nome.toUpperCase()}` : ''}`}
              renderInput={(params) => (
                <TextField
                  {...params}
                  variant="outlined"
                  label="Autorizado por"
                  required
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              )}
            />
          </Grid>

          <Grid item md={6} sm={6} xs={12}>
            <SelecionarData
              dataBD={values.autorizacaodata}
              minDate={dataCadastroVestigio}
              callback={setDataAutorizacao}
              label="Data da autorização"
              required
            />
          </Grid>

          <Grid item md={12} sm={12} xs={12}>
            <TextField
              fullWidth
              label="Número do documento"
              name="autorizacaonumero"
              onChange={(e) => handleChangeWithModification(e, maxLength250)}
              value={values.autorizacaonumero || ''}
              variant="outlined"
              InputLabelProps={{
                shrink: true,
              }}
              required
            />
            <Typography variant="caption" style={{ display: 'block', marginTop: '4px' }}>
              Caracteres restantes: {250 - (values.autorizacaonumero?.length || 0)}
            </Typography>
          </Grid>

          <Grid item md={12} sm={12} xs={12}>
            <TextField
              fullWidth
              label="Observações"
              name="observacoes"
              rows={5}
              onChange={(e) => handleChangeWithModification(e, maxLength250)}
              value={values.observacoes || ''}
              multiline
              variant="outlined"
              InputLabelProps={{
                shrink: true,
              }}
            />
            <Typography variant="caption" style={{ display: 'block', marginTop: '4px' }}>
              Caracteres restantes: {250 - (values.observacoes?.length || 0)}
            </Typography>
          </Grid>

          <Grid item xs={12}>
            <Divider className={classes.dividerBotoes} />
            <div className={classes.botoesFormulario}>
              <CustomButton
                colorType="primary"
                variant="outlined"
                onClick={() => router.history.push(`/casos/caso/vestigio/detalhar/${params.id}`)}
                startIcon={<ArrowBackIcon />}
              >
                Voltar
              </CustomButton>
              <CustomButton
                colorType="primary"
                disabled={!isFormValid || processando}
                isLoading={processando}
                startIcon={<CheckIcon />}
                onClick={abrirModalConfirmacao}
              >
                Confirmar
              </CustomButton>
            </div>
          </Grid>
        </Grid>
      </div>

      <ModalConfirmacao
        aberto={modalConfirmacao}
        onClose={fecharModalConfirmacao}
        onConfirm={descartarVestigio}
        processando={processando}
        titulo="Você tem certeza de que deseja descartar esse vestígio?"
        confirmarLabel="Confirmar Descarte"
        cancelarLabel="Cancelar"
        confirmarColor="secondary"
        maxWidth="sm"
      >
        <Typography variant="body1">
          Esta ação é irreversível e alterará permanentemente o status do vestígio para descartado.
        </Typography>
      </ModalConfirmacao>
    </Page>
  )
}

export default DescartarVestigio
